import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { TRACKED_ROUTES } from "./utils/trackedRoutes";
import { loadLinkedInInsight } from "./utils/linkedin";
import { loadGoogleTag } from "./utils/google";
import { loadMetaPixel } from "./utils/meta";

const InsightTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const clientDomain = process.env.REACT_APP_CLIENT_DOMAIN;
    const isProduction =
      clientDomain && clientDomain.includes("www.plaintr.com");

    // If it's NOT production, we don't track anything
    if (
      !isProduction ||
      !TRACKED_ROUTES.includes(location.pathname)
    ) return;

    loadLinkedInInsight();
    loadGoogleTag();
    loadMetaPixel();
  }, [location.pathname]);

  return null;
};

export default InsightTracker;
